<template>
<div class="checkout-progress checkout-progress--step-0 js-checkout-progress">
     <!-- Pagination -->
  <ul class="checkout-progress__list">
    <li class="checkout-progress__list__item">
      <button class="checkout-progress__list__item__link" @click="stageClicked(0)" v-bind:class="{ 'is-active': stage1 }" aria-label="Go to 'Choose your city' section">
        <span class="checkout-progress__list__item__text">
          <span class="u-sr">Choose your </span>City
        </span>
      </button>
    </li>
    <li class="checkout-progress__list__item">
      <button class="checkout-progress__list__item__link" @click="stageClicked(1)" v-bind:class="{ 'is-active': stage2 }" aria-label="Go to 'Choose your tickets' section">
        <span class="checkout-progress__list__item__text">
          <span class="u-sr">Choose you </span>Tickets
        </span>
      </button>
    </li>
    <li class="checkout-progress__list__item">
      <button class="checkout-progress__list__item__link" @click="stageClicked(2)" v-bind:class="{ 'is-active': stage3 }" aria-label="Go to 'Choose your date and time' section">
        <span class="checkout-progress__list__item__text">
          <span class="u-sr">Choose you </span>Date & Time
        </span>
      </button>
    </li>
    <li class="checkout-progress__list__item">
      <button class="checkout-progress__list__item__link" @click="stageClicked(3)" v-bind:class="{ 'is-active': stage4 }">
        <span class="checkout-progress__list__item__text">
          <span class="u-sr">Choose your </span>Upgrades
        </span>
      </button>
    </li>
    <li class="checkout-progress__list__item">
      <button class="checkout-progress__list__item__link" @click="stageClicked(4)" v-bind:class="{ 'is-active': stage5 }"  aria-label="Go to 'Review your order' section">
        <span class="checkout-progress__list__item__text">
          Review<span class="u-sr"> your order</span>
        </span>
      </button>
    </li>
    <li class="checkout-progress__list__item">
      <button class="checkout-progress__list__item__link" @click="stageClicked(5)" v-bind:class="{ 'is-active': stage6 }" aria-label="Go to 'Make your payment' section">
        <span class="checkout-progress__list__item__text">
          <span class="u-sr">Make your </span>Payment
        </span>
      </button>
    </li>
  </ul>
</div>
</template>

<script>
export default {
    // todo ADD LINKS TO PREVIOUS STAGES
    name: "CheckoutProgress",
    computed: {
        stage1() {
            return this.$store.state.checkout.stage >= 0;
        },
        stage2() {
            return this.$store.state.checkout.stage >= 1;
        },
        stage3() {
            return this.$store.state.checkout.stage >= 2;
        },
        stage4() {
            return this.$store.state.checkout.stage >= 3;
        },
        stage5() {
            return this.$store.state.checkout.stage >= 4;
        },
        stage6() {
            return this.$store.state.checkout.stage >= 5;
        },
        stage: {
            get() {
                return this.$store.state.checkout.stage;
            },
            set(id) {
                this.$store.dispatch('checkout/setStage', id);
            }
        }
    },
    methods: {
        stageClicked(s) {
            this.$emit('stageClicked', s);
        }
    }
}
</script>

<style>

</style>
